import React, { createContext, useContext, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';

const AuthContext = createContext(null);

function loadAuthFromStorage() {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return null;

    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      localStorage.clear();
      return null;
    }

    return {
      token,
      role: decoded.user?.role || localStorage.getItem('userRole') || '',
      companyId: decoded.user?.company_id || localStorage.getItem('companyId') || '',
      companyName: decoded.user?.company || localStorage.getItem('companyName') || '',
      mainCompanyId: decoded.user?.main_company_id || localStorage.getItem('mainCompanyId') || '',
      mainCompanyName: decoded.user?.main_company || localStorage.getItem('mainCompanyName') || '',
    };
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => loadAuthFromStorage());

  useEffect(() => {
    if (!auth) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');
      localStorage.removeItem('companyId');
      localStorage.removeItem('companyName');
      localStorage.removeItem('company');
      localStorage.removeItem('mainCompanyId');
      localStorage.removeItem('mainCompanyName');
    }
  }, [auth]);

  const login = (token) => {
    try {
      const decoded = jwtDecode(token);
      const role = decoded.user?.role || '';
      const companyId = decoded.user?.company_id || '';
      const companyName = decoded.user?.company || '';
      const mainCompanyId = decoded.user?.main_company_id || '';
      const mainCompanyName = decoded.user?.main_company || '';

      localStorage.setItem('authToken', token);
      localStorage.setItem('userRole', role);
      localStorage.setItem('companyId', companyId);
      localStorage.setItem('companyName', companyName);
      localStorage.setItem('company', companyName);
      localStorage.setItem('mainCompanyId', mainCompanyId);
      localStorage.setItem('mainCompanyName', mainCompanyName);

      setAuth({ token, role, companyId, companyName, mainCompanyId, mainCompanyName });
    } catch (e) {
      console.error('Failed to decode token on login', e);
    }
  };

  const logout = () => {
    localStorage.clear();
    setAuth(null);
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
